/* @flow */
import Link from 'components/Link';
import * as React from 'react';

import cx from 'classnames';

class ReportChatModalOption extends React.Component<{
  className?: string,
  children: React.Node,
  disabled: boolean,
}> {
  static defaultProps = {
    disabled: false,
  };

  render() {
    return (
      <Link
        {...this.props}
        bar
        color="chalkboard"
        className={cx(
          {
            'ReportChatModal-button': true,
            'ReportChatModal-button-disabled': this.props.disabled,
          },
          this.props.className
        )}>
        {this.props.children}
      </Link>
    );
  }
}

export default ReportChatModalOption;
